const scale = ['Разногласие', 'Напряжение', 'Повторяющийся конфликт', 'Открытое противостояние', 'Конфликт, влияющий на бизнес'];

const levels = [
  { icon: 'ri-chat-smile-3-line', title: 'Дать договориться самостоятельно', desc: 'Если разногласие рабочее и не повторяется, сотрудникам часто достаточно возможности спокойно обсудить вопрос между собой. Руководителю не нужно решать за них каждую мелочь.' },
  { icon: 'ri-ruler-line', title: 'Задать правила обсуждения', desc: 'Когда дискуссия начинает скатываться на личности, руководитель задаёт рамки: говорим о фактах и задачах, а не о людях, и ищем решение, а не виноватого.' },
  { icon: 'ri-user-star-line', title: 'Вмешаться руководителю', desc: 'Если конфликт повторяется или мешает работе, руководитель включается: помогает сформулировать суть разногласия и вернуть обсуждение к рабочей задаче.' },
  { icon: 'ri-chat-3-line', title: 'Провести отдельный разговор', desc: 'С каждым участником или с обеими сторонами вместе — в зависимости от ситуации. Цель разговора — понять интересы и найти решение, а не устроить «разбор полётов».' },
  { icon: 'ri-building-4-line', title: 'Увидеть системную проблему', desc: 'Если конфликты одного типа повторяются у разных людей, причина, скорее всего, в правилах, KPI, структуре или зонах ответственности. Здесь нужно менять систему, а не только гасить отдельные споры.' },
];

export default function WhenToIntervene() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Не каждый конфликт нужно решать одинаково
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Руководителю важно определить масштаб и последствия ситуации, прежде чем выбирать способ вмешательства
        </p>

        <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8 mb-10">
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 mb-2">
            {scale.map((step, i) => (
              <div key={step} className="flex-1 flex items-center gap-2">
                <div className={`flex-1 rounded-lg px-3 py-3 text-center text-xs font-semibold ${i < 3 ? 'bg-teal-50 text-teal-700 border border-teal-200' : i === 3 ? 'bg-amber-50 text-amber-700 border border-amber-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
                  {step}
                </div>
                {i < scale.length - 1 && <i className="ri-arrow-right-line text-gray-300 flex-shrink-0"></i>}
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4">
          {levels.map((l) => (
            <div key={l.title} className="flex items-start gap-4 bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                <i className={`${l.icon} text-teal-700 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-sm mb-1.5">{l.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{l.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}